import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RevolverService {
  // Just a service to ask Angular nicely to instantiate all its dependencies.
  constructor() {}
}
